<template>

    <div class="keyFigures">
        <div class="keyFigures_col appearEffect">
            <KeyFigure
                    v-for="(figure, index) in figureCol1"
                    :key="index"
                    :title="figure.title"
                    :figure="figure.figure"
                    :figureDecimals="figure.figureDecimals"
                    :suffix="figure.suffix"
                    :prefix="figure.prefix"
                    :icon="figure.icon"
                    :topImage="figure.topImage"
                    :subTitle="figure.subTitle"
                    :content="figure.content"
                    :noCollapse="figure.noCollapse"
                    :source="figure.source"
                    :noMarge="figure.noMarge"
            ></KeyFigure>
        </div>
        <div class="keyFigures_col appearEffect">
            <KeyFigure
                    v-for="(figure, index) in figureCol2"
                    :key="index"
                    :title="figure.title"
                    :figure="figure.figure"
                    :figureDecimals="figure.figureDecimals"
                    :suffix="figure.suffix"
                    :prefix="figure.prefix"
                    :icon="figure.icon"
                    :topImage="figure.topImage"
                    :subTitle="figure.subTitle"
                    :content="figure.content"
                    :noCollapse="figure.noCollapse"
                    :source="figure.source"
                    :noMarge="figure.noMarge"
            ></KeyFigure>
        </div>
    </div>

</template>



<script>
    import KeyFigure from "./KeyFigure";
    export default {
        name: 'KeyFigureList',
        components: {KeyFigure},
        data(){
            return{
                figureCol1: [],
                figureCol2: [],
            };
        },
        props: {
            figures: {
                type: Array,
                default: [],
            },
        },
        methods: {
            /**
             * on scinde juste les key figures du fichier de langue en deux colonnes
             */
            buildKeyFigureCols: function(){
                const splitAt = Math.ceil(this.figures.length / 2);
                this.figures.forEach((elt, index) => {
                    if(index < splitAt){
                        this.figureCol1.push(elt);
                    } else {
                        this.figureCol2.push(elt);
                    }
                });
            },
        },
        mounted(){
            this.buildKeyFigureCols();
        },
    };
</script>

<style scoped lang="scss">
    .keyFigures{
        display: flex;

        &_col {
            padding-right: $G-default*1.5;
            width:50%;
        }
    }
</style>